export function formatClock(ms: number): string {
  const total = Math.max(0, ms);
  if (total < 10_000) return `${Math.floor(total / 1000)}.${Math.floor((total % 1000) / 100)}`;
  const s = Math.ceil(total / 1000);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = String(s % 60).padStart(2, '0');
  return h ? `${h}:${String(m).padStart(2, '0')}:${sec}` : `${m}:${sec}`;
}

export function formatCountdown(ms: number): string {
  const s = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  return `${h}:${String(m).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
}

const compact = new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 });
const full = new Intl.NumberFormat('en');

export const formatNumber = (n: number) => (n >= 10_000 ? compact.format(n) : full.format(n));
export const formatFull = (n: number) => full.format(n);

export function timeControlLabel(tc: { initial: number; increment: number } | null | undefined): string {
  if (!tc || tc.initial === 0) return 'No clock';
  const min = tc.initial / 60;
  return `${Number.isInteger(min) ? min : min.toFixed(1)}+${tc.increment}`;
}

export function relativeTime(ms: number, now = Date.now()): string {
  const d = Math.round((now - ms) / 1000);
  if (d < 60) return 'just now';
  if (d < 3600) return `${Math.floor(d / 60)}m ago`;
  if (d < 86400) return `${Math.floor(d / 3600)}h ago`;
  if (d < 86400 * 30) return `${Math.floor(d / 86400)}d ago`;
  return new Date(ms).toLocaleDateString();
}

export function ordinal(n: number): string {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

/** "1 game", "3 games". */
export function plural(n: number, word: string, many = `${word}s`): string {
  return `${formatNumber(n)} ${n === 1 ? word : many}`;
}
